import { render, staticRenderFns } from "./InactiveHealth.vue?vue&type=template&id=800b67fe&"
import script from "./InactiveHealth.vue?vue&type=script&lang=js&"
export * from "./InactiveHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports